import {
  CardCreateSource,
  cardToAnalytics,
  dashboardToAnalytics,
  SavedObjectOverrides,
  trackCardSaved,
  trackUserBaseSelector,
} from '@fullstory/analytics';
import { Card } from '@fullstory/proto/fs/services/dx-objects';
import { int64 } from '@fullstory/proto/google/protobuf';
import {
  useAllSavedFunnels,
  useAllSavedMetrics,
  useDashboardCardActions,
  useSavedHeatmaps,
} from '@fullstory/redux';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toDashboardCardAnalytics } from '../utils';

export const useCreateDashboardCard = (dashboardOverlayHash?: string) => {
  const dashboardCardsActions = useDashboardCardActions(dashboardOverlayHash);
  const { byId: funnelsById } = useAllSavedFunnels();
  const { byId: metricsById } = useAllSavedMetrics();
  const { byId: heatmapsById } = useSavedHeatmaps();
  const userAnalytics = useSelector(trackUserBaseSelector);

  const createDashboardCard = useCallback(
    async (
      dashboardId: int64,
      card: Card,
      cardCreateSource: CardCreateSource,
      insertAt?: int64 | null,
      savedObjectOverrides?: SavedObjectOverrides,
    ) => {
      const rsp = await dashboardCardsActions.create(dashboardId, card, insertAt ?? null);

      const cardAnalytics = cardToAnalytics(
        rsp?.card,
        metricsById,
        funnelsById,
        heatmapsById,
        savedObjectOverrides,
      );
      const dashboardAnalytics = dashboardToAnalytics(rsp?.dashboard ?? undefined);

      if (cardAnalytics && rsp?.card) {
        trackCardSaved({
          ...userAnalytics,
          ...cardAnalytics,
          ...dashboardAnalytics,
          ...toDashboardCardAnalytics(rsp.card, rsp.dashboard?.id),
          is_new_bool: true,
          create_source_str: cardCreateSource,
        });
      }
    },
    [dashboardCardsActions, funnelsById, heatmapsById, metricsById, userAnalytics],
  );

  return createDashboardCard;
};
